module.exports = __webpack_public_path__ + "img/dot.ba1aa3c8.svg";